import type {
	OriginalStimulusTypes,
	Slide,
} from "@memorang/types/src/session/new-session";
import type { TFunction } from "i18next";

const getSlidesData = (slides?: Slide[]) => {
	return (
		slides
			?.filter((slide) => slide.media?.length && slide.media?.length > 0)
			.map((slide) => ({
				image:
					slide.media?.find(
						(m) =>
							m.type === "image" || m.type === "IMAGE" || m.type === "images",
					)?.url ?? "a",
				audio:
					slide.media?.find((m) => m.type === "audio" || m.type === "AUDIO")
						?.url ?? "",
			})) ?? []
	);
};

const getIsSlidesHasPassage = (slides?: Slide[]) => {
	return slides?.some((slide) => slide?.passage != null);
};

const getStimulusData = (stimulusType: OriginalStimulusTypes, t: TFunction) => {
	switch (stimulusType) {
		case "READING":
			return {
				text: t("session.passageStem.passage"),
				icon: "book-open-page-variant-outline",
			};
		case "LISTENING":
			return {
				text: t("session.passageStem.lecture"),
				icon: "book-open-page-variant-outline",
			};
		case "ACADEMIC_DISCUSSION_STIMULUS":
			return {
				text: t("session.passageStem.professorsQuestion"),
				icon: "book-open-page-variant-outline",
			};
		case "INTEGRATED_WRITING_STIMULUS":
			return {
				text: t("session.passageStem.lecture"),
				icon: "book-open-page-variant-outline",
			};
		case "LS_STIMULUS":
		case "RLS_STIMULUS":
		case "INDEPENDENT_SPEAKING_STIMULUS":
			return { text: t("session.passageStem.listen"), icon: "headphones" };
		default:
			return {
				text: t("session.passageStem.passage"),
				icon: "page-next-outline",
			};
	}
};

const isAiSimulationItem = (item?: { metadata?: { taskType?: string } }) =>
	(item?.metadata as { taskType?: string } | undefined)?.taskType ===
	"AI_SIMULATION";

const getHasParentStem = (
	parentStem?: { length: number } | null,
	parentTitle?: string | null,
	isMobile?: boolean,
) =>
	Boolean(
		(parentStem && parentStem.length > 0) ||
			(parentTitle && parentTitle.length > 0 && !isMobile),
	);

export {
	getSlidesData,
	getIsSlidesHasPassage,
	getStimulusData,
	isAiSimulationItem,
	getHasParentStem,
};
